module.exports = __webpack_public_path__ + "img/print01.99a1151e.png";